import type { MarketPartyOrSubUnitResponse } from '#pie/internal/api/pie-bff';
import { createSortingAtom } from './createSortingAtom';
import type { DefaultSorting } from './defaultSorting';

export const defaultInvoiceContactSorting: DefaultSorting<MarketPartyOrSubUnitResponse> =
  {
    desc: false,
    id: 'name',
  };

export const invoiceContactSortingAtom = createSortingAtom({
  defaultSorting: defaultInvoiceContactSorting,
});
